import { Link } from 'react-router-dom';

export default function FeaturedSnippetSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-flashlight-line text-sm"></i>
              Quick Answer
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-4">
              Quick Answer: What is OOPBuy Spreadsheet?
            </h3>
            <p className="text-base text-foreground-700 leading-relaxed">
              <strong>OOPBuy Spreadsheet</strong> is a structured online system that helps users compare, organize, and manage product purchases using spreadsheet-style data, making shopping more efficient and transparent. It combines the clarity of a product comparison tool with the convenience of a centralized buying agent system, enabling users to analyze listings, track prices, and streamline their entire online shopping workflow from one unified interface.
            </p>
          </div>

          <div className="bg-primary-50 rounded-2xl p-8 md:p-10 border border-primary-200/50">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-6">
              Start Learning More
            </h3>
            <ul className="space-y-4">
              {links.map((link, i) => (
                <li key={i}>
                  {link.internal ? (
                    <Link
                      to={link.url}
                      className="flex items-center gap-3 text-foreground-700 hover:text-primary-600 transition-colors group cursor-pointer"
                    >
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-200 transition-colors flex-shrink-0">
                        <i className={`${link.icon} text-sm`}></i>
                      </div>
                      <span className="text-sm font-medium">{link.label}</span>
                      <i className="ri-arrow-right-line text-base ml-auto opacity-60 group-hover:opacity-100 transition-opacity"></i>
                    </Link>
                  ) : (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 text-foreground-700 hover:text-primary-600 transition-colors group cursor-pointer"
                    >
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                        <i className={`${link.icon} text-sm`}></i>
                      </div>
                      <span className="text-sm font-medium">{link.label}</span>
                      <i className="ri-arrow-right-up-line text-base ml-auto opacity-60 group-hover:opacity-100 transition-opacity"></i>
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

const links = [
  {
    label: 'What is OOPBuy Spreadsheet?',
    url: '/',
    icon: 'ri-question-line',
    internal: true,
  },
  {
    label: 'How to Use OOPBuy Spreadsheet',
    url: '/oopbuy-spreadsheet-guide',
    icon: 'ri-guide-line',
    internal: true,
  },
  {
    label: 'OOPBuy Spreadsheet vs Alternatives',
    url: '/oopbuy-spreadsheet-guide',
    icon: 'ri-scales-line',
    internal: true,
  },
  {
    label: 'OOPBuy Spreadsheet Safety Guide',
    url: '/oopbuy-spreadsheet-guide',
    icon: 'ri-shield-check-line',
    internal: true,
  },
  {
    label: 'Buying Tips &amp; Best Practices',
    url: '/oopbuy-spreadsheet-buying-guide',
    icon: 'ri-lightbulb-line',
    internal: true,
  },
  {
    label: 'Visit Official Platform',
    url: 'https://kaspreadsheet.com/',
    icon: 'ri-external-link-line',
    internal: false,
  },
];